export enum ProjectInfoState {
    NotStarted = 'not-started',
    Saving = 'saving',
    Done = 'done',
    Error = 'error',
}
